import {
  SectionApi,
  QuestionApi,
} from '@/openapi/master/';
import { CourseId } from '@/openapi/enum';

import ApiUtility from '@/classes/common/ApiUtility';
import TypeStrictData from '@/classes/common/TypeStrictData';
import SectionData from '@/classes/data/SectionData';
import QuestionData from '@/classes/data/QuestionData';




export default class MasterApiUtility extends ApiUtility {

  /** APIの基本パス（継承先でこれを変更すれば他のAPIにアクセスできる想定） */
  protected static readonly apiBasePath = `${process.env.VUE_APP_PUBLIC_PATH}master`;

  /** 400エラーを異常系として処理 */
  protected static readonly isBadRequestResolved: boolean = false;



  /**
   * 指定科目IDの単元一覧を取得します
   *
   * @param courseId
   */
  public static async getSections(courseId: CourseId): Promise<SectionData[]> {
    const response = await this.getSectionApi().listSection(courseId);
    return this.parseTsv(SectionData, response.data);
  }

  /**
   * 指定科目ID、単元Noの問題一覧を取得します
   *
   * @param courseId
   * @param sectionNo
   */
  public static async getQuestions(courseId: CourseId, sectionNo: number): Promise<QuestionData[]> {
    const sectionCode   = `section${String(sectionNo).padStart(2, '0')}`;
    const questionsFile = `${sectionCode}.txt`;
    const response      = await this.getQuestionApi().listQuestion(courseId, sectionCode, questionsFile);
    return this.parseTsv(QuestionData, response.data);
  }

  /**
   * openapi-generatorで生成した単元API通信用クラスを取得します
   *
   * @returns
   */
  public static getSectionApi(): SectionApi {
    return new SectionApi(undefined, this.apiBasePath, this.getInstance(false));
  }

  /**
   * openapi-generatorで生成した問題API通信用クラスを取得します
   *
   * @returns
   */
  public static getQuestionApi(): QuestionApi {
    return new QuestionApi(undefined, this.apiBasePath, this.getInstance(false));
  }

  /**
   * TSV文字列を指定クラスの配列に変換します
   *
   * @param type 返却対象クラス型種別
   * @param tsv TSV文字列
   * @return 指定クラスの配列
   */
  private static parseTsv<T extends TypeStrictData>(type: {new(): T}, tsv: string): T[] {
    return this.parseByDelimiter(type, tsv, '\t');
  }

  /**
   * CSV文字列を指定クラスの配列に変換します
   *
   * @param type 返却対象クラス型種別
   * @param csv TSV文字列
   * @return 指定クラスの配列
   */
  private static parseCsv<T extends TypeStrictData>(type: {new(): T}, csv: string): T[] {
    return this.parseByDelimiter(type, csv, ',');
  }

  /**
   * 指定分割文字の文字列フォーマットを指定クラスの配列に変換します
   *
   * @param type 返却対象クラス型種別
   * @param text 文字列フォーマット
   * @return 指定クラスの配列
   */
  private static parseByDelimiter<T extends TypeStrictData>(type: {new(): T}, text: string, splitter: string): T[] {
    const list: T[] = [];
    const rows: string[] = text.split('\n');
    const keys: string[] = rows[0].split(splitter);
    for (let rowIndex = 1; rowIndex < rows.length; rowIndex++) {
      if (rows[rowIndex].length === 0) continue;
      const values: string[] = rows[rowIndex].split(splitter);
      // 指定クラスを生成・初期化し、listに追加
      const each: T = new type();
      each.init(keys, values);
      list.push(each);
    }
    return list;
  }



}
